import { useState } from "react";

interface OTPInputProps {
    length?: number;
    onChange: (otp: string) => void;
}

const OTPInput = ({ length = 6, onChange }: OTPInputProps) => {
    const [otp, setOtp] = useState(Array(length).fill(""));

    const handleChange = (value: string, idx: number) => {
        if (!/^\d?$/.test(value)) return;

        const updated = [...otp];
        updated[idx] = value;
        setOtp(updated);
        onChange(updated.join(""));
    };

    return (
        <div className="flex gap-2 justify-center">
            {otp.map((digit, idx) => (
                <input
                    key={idx}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(e.target.value, idx)}
                    className="w-10 h-12 text-xl text-center border rounded"
                />
            ))}
        </div>
    );
};

export default OTPInput;
